import { render, staticRenderFns } from "./LiveVideosChapter.vue?vue&type=template&id=fbb69714&scoped=true&"
import script from "./LiveVideosChapter.vue?vue&type=script&lang=js&"
export * from "./LiveVideosChapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb69714",
  null
  
)

export default component.exports